import { RefreshCw } from 'lucide-react'

import { Button, ProductThumb, StatusMessage } from '@krp/ui-kit'

import { ActionError } from '../../../shared/ActionError'
import type { TestingAccess, TestingCheckActions, TestingCheckVm } from '../model/types'
import { StateBadge, TestingGate } from './TestingParts'

/**
 * Проверка кадра: тот же путь, что у боевого поиска, — каждая дорожка отдельно
 * и после слияния. Видно, на каком месте нужный товар и кто его обогнал.
 */
export function TestingCheckScreen({
  access,
  frameUrl,
  vm,
  actions,
}: {
  access: TestingAccess
  frameUrl: string
  vm: TestingCheckVm
  actions: TestingCheckActions
}) {
  return (
    <TestingGate access={access}>
      <section aria-labelledby="platform-testing-check-title" className="platform-testing">
        <header className="platform-resources__toolbar">
          <h2 id="platform-testing-check-title">Проверка кадра</h2>
          <Button
            variant="ghost"
            icon={<RefreshCw size={16} aria-hidden="true" />}
            busy={vm.busy}
            onClick={actions.recheck}
            actionId="platform.testing-check.recheck"
          >
            Проверить снова
          </Button>
        </header>
        <ProductThumb src={frameUrl} name="Проверяемый кадр" size={160} />
        <ActionError error={vm.error} />
        {vm.busy && <StatusMessage kind="loading" title="Ищем…" />}
        {vm.recognized !== null && <p>{vm.recognized}</p>}
        {vm.latency !== null && <p className="platform-testing__note">Время ответа: {vm.latency}</p>}
        {vm.lanes.map((lane) => (
          <section key={lane.lane} aria-label={lane.title}>
            <h3>{lane.title}</h3>
            <p>
              <StateBadge badge={lane.verdict} />
              {lane.margin === null ? null : <span className="platform-testing__note"> · {lane.margin}</span>}
            </p>
            {lane.hits.length === 0 ? (
              <p className="platform-testing__note">Дорожка ничего не нашла</p>
            ) : (
              <ol className="platform-testing__hits">
                {lane.hits.map((hit) => (
                  <li key={`${hit.rank}`} value={hit.rank} data-expected={hit.expected || undefined}>
                    {hit.name} — уверенность {hit.confidence}
                    {hit.parts === '' ? null : <small> ({hit.parts})</small>}
                    {hit.matchedBy === '' ? null : <small> · найден по: {hit.matchedBy}</small>}
                    {hit.expected ? <strong> · нужный товар</strong> : null}
                  </li>
                ))}
              </ol>
            )}
          </section>
        ))}
      </section>
    </TestingGate>
  )
}
